let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const SCALE_FACTOR_BY_SIZE = {
  xxs: 0,
  xs: 0,
  sm: 0.55,
  md: 0.65,
  lg: 0.75,
  xl: 1,
  responsive: 0
};
const OFFSET_PERCENTAGE_BY_SIZE = {
  xxs: 0,
  xs: 0,
  sm: 35,
  md: 50,
  lg: 58,
  xl: 62,
  responsive: 0
};
const AvatarBadgeWrapper = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  bottom: -8%;
  left: ${0};
  transform: scale(${0});
  transform-origin: bottom left;
`), ({
  $size
}) => `${OFFSET_PERCENTAGE_BY_SIZE[$size]}%`, ({
  $size
}) => SCALE_FACTOR_BY_SIZE[$size]);
export const AvatarBadgeHolder = ({
  AvatarBadge,
  size
}) => {
  if (!AvatarBadge) return null;
  return /*#__PURE__*/_jsx(AvatarBadgeWrapper, {
    $size: size,
    children: /*#__PURE__*/_jsx(AvatarBadge, {})
  });
};